import { render, staticRenderFns } from "./ArticleSliderBNG.vue?vue&type=template&id=c29c1370"
import script from "./ArticleSliderBNG.vue?vue&type=script&lang=js"
export * from "./ArticleSliderBNG.vue?vue&type=script&lang=js"
import style0 from "./ArticleSliderBNG.vue?vue&type=style&index=0&id=c29c1370&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports